// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer[data-v-4979356c]{z-index:1000;position:fixed;width:100%;height:100%;top:auto;left:100%;bottom:auto;right:auto;background:red}.layer-2[data-v-4979356c]{background:#00f;animation-delay:.2s}.from-right-to-left[data-v-4979356c]{animation-name:example-4979356c;animation-duration:.9s}@keyframes example-4979356c{0%{left:100%}99%{left:-100%;opacity:1}to{opacity:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
